import { BufferedObservable } from '../tools/observable';
import { trackRuntimeError } from './error/trackRuntimeError';
var BUFFER_LIMIT = 500;
export function startBufferingData() {
  var trackRuntimeErrorImpl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trackRuntimeError;
  var observable = new BufferedObservable(BUFFER_LIMIT);
  var runtimeErrorSubscription = trackRuntimeErrorImpl().subscribe(function (error) {
    observable.notify({
      type: 0 /* BufferedDataType.RUNTIME_ERROR */,
      error: error
    });
  });
  return {
    observable: observable,
    stop: function stop() {
      runtimeErrorSubscription.unsubscribe();
    }
  };
}